import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';
import UserDoc from '../../models/UserDoc';

async function updateUser(
  userDoc: UserDoc,
  auth: Authentication
): Promise<void> {
  try {
    if (
      ![UserRole.owner, UserRole.admin, UserRole.maintainer].includes(auth.role)
    ) {
      throw new UpdateUserFailure('Unauthorized', 'unauthorized');
    }
    await HttpClient.put('/user', userDoc.toPatch(), auth.token);
    return;
  } catch (e) {
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new UpdateUserFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new UpdateUserFailure(`Erreur lors de la mise à jour de l'utilisateur : ${e.message}`, "400");
    }
  }
}

export class UpdateUserFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default updateUser;
